
const SKELETON_KEYS = ["skel-1", "skel-2", "skel-3"] as const;

export const LoadingSkeleton = () => {
  return (
    <div className="w-full animate-fadeIn">
      {SKELETON_KEYS.map((key) => (
        <div
          key={key}
          className={`
            flex items-center gap-3 mb-2 p-2 rounded-lg 
            bg-gray-50 transition-colors duration-300
            hover:bg-gray-100
          `}
        >
          {/* Small circular avatar / icon skeleton */}
          <div className="w-6 h-6 rounded-full bg-gray-200 animate-pulse-slow" />

          {/* Text content */}
          <div className="flex-1 space-y-2">
            <div className="h-6 w-3/5 rounded bg-gray-200 animate-pulse-slow" />
            <div className="h-4 w-2/5 rounded bg-gray-200 animate-pulse-slow" />
          </div>

          {/* Action button / avatar skeleton */}
          <div className="w-10 h-10 rounded-full bg-gray-200 animate-pulse-slow" />
        </div>
      ))}
    </div>
  );
};
